export const RESOLUTION_TYPES = [
  { id: 'AppointmentScheduled', name: 'Appointment Scheduled' },
  { id: 'StatusInfoProvided', name: 'Status Information Provided' },
  { id: 'PartsRequestFulfilled', name: 'Parts Request Fulfilled' },
  { id: 'QuestionAnswered', name: 'Question Answered' },
  { id: 'CallbackAttemptedNoAnswer', name: 'Callback Attempted - No Answer' },
  { id: 'ContactInfoInvalid', name: 'Customer Contact Information Invalid' },
  { id: 'Duplicate', name: 'Duplicate' },
  { id: 'TransferredDepartment', name: 'Transferred to Different Department' },
  { id: 'RequestCanceled', name: 'Customer Request Canceled/Withdrawn' },
];
